<template>
	<div>
		<main style='background: #EEEEEE;height: 900px;'>
			<img src="../../assets/images/banner_bg.jpg" alt="" class="topImg">
			<div class="centerBox">
				<div class="liucheng">
					<div>
						<p class="title">我要咨询</p>
						<div class="boxItems">
							<div class="boxItem">
								<p>所属类别：</p>
								<el-select v-model="valuetype" placeholder="请选择问题类别">
									<el-option v-for="item in options" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
							<div class="boxItem">
								<p>我的姓名：</p>
								<el-input v-model="username" placeholder="请输入相应内容"></el-input>
							</div>
							<div class="boxItem">
								<p>标题：</p>
								<el-input v-model="title" placeholder="请输入相应内容"></el-input>
							</div>
							<div class="boxItem">
								<p>内容：</p>
								<el-input type="textarea" placeholder="请输入相应内容" v-model="content" maxlength="40"
									show-word-limit>
								</el-input>
							</div>
							<div class="boxItem">
								<p>联系地址：</p>
								<el-input v-model="address" placeholder="请输入相应内容"></el-input>
							</div>
							<div class="boxItem">
								<p>手机号：</p>
								<el-input v-model.number="tel" type='number' placeholder="请输入相应内容"></el-input>
							</div>
							<div class="boxItem">
								<p>电子邮箱：</p>
								<el-input v-model="email" placeholder="请输入相应内容"></el-input>
							</div>
							<div class="boxItem">
								<p>是否公开：</p>
								<el-select v-model="isOpen" placeholder="请选择是否公开">
									<el-option v-for="item in options1" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
							<p class="btn" @click="question">提交咨询</p>
						</div>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	import navheader from '../../components/navheader.vue'
	import footeritem from '../../components/footeritem.vue'
	import axios from 'axios'
	import '../../assets/css/index.less'
	import '../../assets/css/fuWu.less';
	export default {
		name: 'Pdf',
		components: {
			navheader,
			footeritem
		},
		data() {
			return {
				valuetype: '',
				username: '',
				content: '',
				title: '',
				address: '',
				tel: '',
				email: '',
				isOpen: '',//是否公开
				options: [{
						value: '1',
						label: '法医类'
					},
					{
						value: '3',
						label: '物证类'
					},
					{
						value: '2',
						label: '声像资料类'
					}, {
						value: '4',
						label: '环境损害类'
					}
				],
				options1: [{
					value: '2',
					label: '是'
				}, {
					value: '1',
					label: '否'
				}],
				value: '',
				activeNum: 0,
				list: [{
						name: '关于协会'
					},
					{
						name: '协会简介'
					},
					{
						name: '协会章程'
					},
					{
						name: '组织机构'
					},
					{
						name: '理事会'
					},
					{
						name: '秘书处'
					},
				],
			};
		},
		methods: {
			question() {
				var that = this
				var telRex = /^1(3|4|5|6|7|8|9)\d{9}$/;
				var emailRex = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
				 if (that.valuetype == '') {
				 	this.$message({
				 		message: '请选择所属类别',
				 		type: 'warning'
				 	});
				 	return false;
				 }else if (that.username == '') {
					this.$message({
						message: '姓名不能为空',
						type: 'warning'
					});
					return false;
				} else if (that.title == '') {
					this.$message({
						message: '标题不能为空',
						type: 'warning'
					});
					return false;
				} else if (that.content == '') {
					this.$message({
						message: '内容不能为空',
						type: 'warning'
					});
					return false;
				}else if (that.address == '') {
					this.$message({
						message: '联系地址不能为空',
						type: 'warning'
					});
					return false;
				}else if (that.tel == '') {
					this.$message({
						message: '手机号不能为空',
						type: 'warning'
					});
					return false;
				} else if (!telRex.test(that.tel)) {
					this.$message({
						message: '输入的手机号有误',
						type: 'warning'
					});
					return false;
				}else if (that.email == '') {
					this.$message({
						message: '邮箱不能为空',
						type: 'warning'
					});
					return false;
				}else if (!emailRex.test(that.email)) {
					this.$message({
						message: '输入的邮箱有误',
						type: 'warning'
					});
					return false;
				}else if (that.isOpen == '') {
					this.$message({
						message: '请选择是否公开',
						type: 'warning'
					});
					return false;
				}
				var params = new URLSearchParams();
				// params.append('username', that.username)
				// params.append('password', that.password)
				// params.append('phone', that.tel)
				axios.post('/system/consulting/question', {
					'realName': that.username,
					'title': that.title,
					'phone': that.tel,
					'openFlag': that.isOpen,
					'address': that.address,
					'context': that.content,
					'email': that.email,
					'evidenceType': that.valuetype
				}, {
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'Customer-Token':localStorage.getItem('token')
					}
				}).then(res => {
					if (res.data.code == 200) {
						this.$message({
							message: '提交成功',
							type: 'success'
						});

						this.$router.push('/')
					}else if(res.data.code == 203){
						this.$message({
							message: '登录失效，请重新登录',
							type: 'warning'
						});
						that.$router.push('/jdapply')
					}
				}, err => {})
			}
		},
		created() {

		},
		mounted() {
			let that = this;
		},
	};
</script>

<style lang="less" scoped="scoped">
	.topImg {
		width: 100%;
		display: block;
	}

	.centerBox {
		width: 1134px;
		margin: 0 auto;
		overflow: hidden;
		box-sizing: border-box;
	}

	.titleTip {
		width: 100%;
		border-left: 4px solid #01458E;
		padding-left: 10px;
	}

	.liucheng {
		position: absolute;
		top: 300px;
		left: 50%;
		margin-left: -500px;

		// background: #F8F8F8;
		// padding: 30px 0;
		&>div {
			width: 1000px;
			height: 700px;
			margin: 0 auto;
			box-shadow: 0px 0px 0px NaNpx rgba(4, 32, 89, 0.15);
			box-sizing: border-box;
			border-radius: 10px;
			background: #fff;
			overflow: hidden;

			.title {
				width: 100%;
				height: 67px;
				line-height: 67px;
				background: #0068d8;
				padding: 0 30px;
				box-sizing: border-box;
				font-size: 22px;
				font-family: Microsoft YaHei, Microsoft YaHei-Bold;
				font-weight: 700;
				text-align: left;
				color: #ffffff;
				letter-spacing: 1px;
			}

			.boxItems {
				width: 100%;
				padding: 50px 230px;
				box-sizing: border-box;
				overflow: hidden;

				.boxItem {
					width: 100%;
					margin-bottom: 15px;
					overflow: hidden;
					display: flex;
					align-items: center;

					p {
						width: calc(20% - 15px);
						font-size: 16px;
						text-align: right;
						font-family: Microsoft YaHei, Microsoft YaHei-Regular;
						font-weight: 400;
						color: #666666;
					}

					.el-select,
					.el-input,
					.el-textarea {
						width: 420px;
						margin-left: 15px;
					}
				}

				.btn {
					width: 200px;
					height: 61px;
					line-height: 61px;
					background: #0068d8;
					border-radius: 15px;
					box-shadow: 0px 0px 0px NaNpx rgba(4, 32, 89, 0.15);
					font-size: 18px;
					font-family: Microsoft YaHei, Microsoft YaHei-Bold;
					font-weight: 700;
					text-align: left;
					color: #ffffff;
					margin: 0 auto;
					margin-top: 30px;
					text-align: center;
					cursor: pointer;
				}
			}

		}

		@media screen and (max-width: 1024px) {
			&>div {
				width: 90%;
			}
		}
	}
</style>
